import { Component } from '@angular/core';
import { SelectedLeadListComponent } from './selected-lead-list/selected-lead-list.component';
import { SelectedLeadsMapComponent } from './selected-leads-map/selected-leads-map.component';
import { Router } from '@angular/router';
import {
  FooterButton,
  FooterService,
} from '../../reusable-components/footer/footer.service';

@Component({
  selector: 'app-selected-leads-view',
  imports: [SelectedLeadListComponent, SelectedLeadsMapComponent],
  templateUrl: './selected-leads-view.component.html',
  styleUrl: './selected-leads-view.component.scss',
  providers: [],
})
export class SelectedLeadsViewComponent {
  constructor(
    private router: Router,
    private footerService: FooterService,
  ) {
    this.footerService.setLeftButton(this.backButton);
    this.footerService.clearRightButton();
  }

  backButton: FooterButton = {
    label: 'components.selected-leads-view.back',
    click: () => {
      this.router.navigate(['/lead-pool']);
    },
  };
}
